
function getCookie(name) {
    function escape(s) { return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1'); };
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
    return match ? match[1] : null;
}

function getCheckoutTimerCookie() {
	return getCookie('coTimer');
}
        
        
function setCheckoutTimerCookie() {
  	setCookie('coTimer', 15);
}

function expireCheckoutTimerCookie() {
  	setCookie('coTimer', -1);
}

function setCookie(name, minutes) {
  	var d = new Date();
    d.setTime(d.getTime() + (minutes*60*1000));

    var expires = "expires="+ d.toUTCString();
    document.cookie = name + "=" + escape(d.toUTCString()) + ";" + expires + ";path=/";
}

function postToApiCall(data, method)
{
    $.ajax({
      url : "https://www.egateway.co/tracking_website/api/" + method +"/",
      type: "POST",
      data : data,
      success: function(data, textStatus, jqXHR)
      {
        //data - response from server
        console.log("data: " + data);
        //alert("data: " + data);
      },
      error: function(jqXHR, textStatus, errorThrown)
      {
        //alert("jqXHR: " + jqXHR);
      }
    });
}

var apicheck = "";
var cryptMethod = "b64enc";

// $(document).ready(function() {
//   	var data = { null: "null" };
//   	apicheck = "";
//   	if (Shopify.Checkout.step === 'contact_information') {
		
//         $.ajax({
//               url : "https://www.egateway.co/tracking_website/api/getaccesskey/",
//               type: "POST",
//               data : data,
//               success: function(data, textStatus, jqXHR)
//               {
//                 //data - response from server
//                 console.log("data: " + data);
//                 apicheck = data;
//               },
//               error: function(jqXHR, textStatus, errorThrown)
//               {
//                 //alert("jqXHR: " + jqXHR);
//               }
//         });
      	
//     }
// });